import { NavigationContainer } from "@react-navigation/native";

import RootStackNavigator from "./RootStack";

import { FeatureFlagsProvider } from "@src/lib/FeatureFlags";
import { linking } from "./linking";
import { useCallback, useEffect } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { DEEP_LINK, NAV_HISTORY_KEY } from "@src/types";
import { InteractionManager } from "react-native";
import { useURL } from "@src/screens/RootScreen/useUrl";
import { checkDeepLinkResult, navigationRef } from "@src/providers/DeepLinkingService";
import { useDeepLinking } from "@src/providers/DeepLinkingProvider";
import { useAuth } from "react-oidc-context";
import { useCurrentUser } from "@src/hooks";
import { initPendoSessionWithEmailOnly } from "@src/lib/Analytics/Pendo/pendoUtils";

const Navigator = (): JSX.Element => {
  const link = useURL();
  const { currentUser } = useCurrentUser();

  const { addDeepLink, deepLinksState, removeDeepLink } = useDeepLinking();
  const { signinRedirect, isAuthenticated, isLoading } = useAuth();

  const handleDeepLink = useCallback(
    (url: string) => {
      const task = InteractionManager.runAfterInteractions(async () => {
        const { action, linkPath, permitDeepLinkInit } = checkDeepLinkResult(url);
        if (!permitDeepLinkInit || !action) return;
        const linkObj = { rawUrl: linkPath, action };

        try {
          await AsyncStorage.setItem(DEEP_LINK, JSON.stringify(linkObj));
        } catch (err) {
          console.error("DEEPLINK ERROR", err);
        }
        addDeepLink(linkObj);
        signinRedirect();
      });

      return () => task.cancel();
    },
    [navigationRef]
  );

  useEffect(() => {
    if (!link || isLoading || isAuthenticated) return;
    handleDeepLink(link);
  }, [link, isLoading, isAuthenticated, handleDeepLink]);

  useEffect(() => {
    if (process.env.REACT_APP_Pendo_App_Id && currentUser) {
      initPendoSessionWithEmailOnly(currentUser.emailAddress);
    }
  }, [currentUser]);

  return (
    <NavigationContainer
      ref={navigationRef}
      onStateChange={async (state) => {
        AsyncStorage.setItem(NAV_HISTORY_KEY, JSON.stringify(state));
        // TODO: revisit on next release
        // const currentProfileId = await getCurrentUserProfileId();
        // const currentRoute = state?.routes[state.index]?.name;

        // if (
        //   currentProfileId === undefined &&
        //   currentRoute !== "RootScreen" &&
        //   currentRoute !== "Logout" &&
        //   currentRoute !== "AuthCallback"
        // ) {
        //   navigationRef.current?.navigate("Logout");
        // }
      }}
      linking={linking}
    >
      <FeatureFlagsProvider>
        <RootStackNavigator />
      </FeatureFlagsProvider>
    </NavigationContainer>
  );
};

export default Navigator;
